// extracted by mini-css-extract-plugin
module.exports = {"choice":"ToggleButton_choice__1qLtc","variant3":"ToggleButton_variant3__3VmRh","variant4":"ToggleButton_variant4__1v_ow","variant19":"ToggleButton_variant19__fRb0y"};